import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/Home',
            name: 'Home',
            component: () =>
                import ('@/views/Home/Home'),
            meta: {
                title: "溯源页面",
                requireAuth: true,
            }
        },
        {
            path: '/Center',
            name: 'Center',
            component: () =>
                import ('@/views/Center/Center'),
            meta: {
                title: "个人中心",
                requireAuth: true,
            }
        },
        {
            path: '/Position',
            name: 'Position',
            component: () =>
                import ('@/views/Position/PositionList'),
            meta: {
                title: "地址管理",
                requireAuth: true,
            },
            children: [{
                    path: '/AddPosition',
                    name: 'AddPosition',
                    component: () =>
                        import ('@/views/Position/AddPosition'),
                    meta: {
                        title: "新增地址",
                        requireAuth: true,
                    }
                },
                {
                    path: '/EditPosition',
                    name: 'EditPosition',
                    component: () =>
                        import ('@/views/Position/EditPosition'),
                    meta: {
                        title: "修改地址",
                        requireAuth: true,
                    }
                },
            ]
        },
        {
            path: '/Dividend',
            name: 'Dividend',
            component: () =>
                import ('@/views/Dividend/DividendList'),
            meta: {
                title: "红包管理",
                requireAuth: true,
            }
        },
        {
            path: '/Integral',
            name: 'Integral',
            component: () =>
                import ('@/views/Integral/IntegralList'),
            meta: {
                title: "积分管理",
                requireAuth: true,
            }
        },
        {
            path: '/ScanCode',
            name: 'ScanCode',
            component: () =>
                import ('@/views/ScanCode/ScanCodeList'),
            meta: {
                title: "扫码记录",
                requireAuth: true,
            }
        },
        {
            path: '/Gift',
            name: 'Gift',
            component: () =>
                import ('@/views/Gift/GiftList'),
            meta: {
                title: "礼品商城",
                requireAuth: true
            }
        },
        {
            path: '/Phone',
            name: 'Phone',
            component: () =>
                import ('@/views/Phone/Phone'),
            meta: {
                title: "绑定手机号",
                requireAuth: true
            }
        },
        {
            path: '/GiftListzq',
            name: 'GiftListzq',
            component: () =>
                import ('@/views/Gift/GiftListzq'),
            meta: {
                title: "商品详情",
                requireAuth: true
            }
        },
        {
            path: '/GiftListkd',
            name: 'GiftListkd',
            component: () =>
                import ('@/views/Gift/GiftListkd'),
            meta: {
                title: "商品详情",
                requireAuth: true
            }
        },
        {
            path: '/fnedeemed',
            name: 'Fnedeemed',
            component: () =>
                import ('@/views/fnedeemed/fnedeemed'),
            meta: {
                title: "已兑换",
                requireAuth: true
            }
        },
        {
            path: '/fnedeemeddetails',
            name: 'Fnedeemeddetails',
            component: () =>
                import ('@/views/fnedeemed/fnedeemeddetails'),
            meta: {
                title: "已兑换详情",
                requireAuth: true
            }
        },
        {
            path: '/fnedeemedselfaccess',
            name: 'Fnedeemedselfaccess',
            component: () =>
                import ('@/views/fnedeemed/fnedeemedselfaccess'),
            meta: {
                title: "已兑换详情",
                requireAuth: true
            }
        },
        {
            path: '/fngoods',
            name: 'Fngoods',
            component: () =>
                import ('@/views/fngoods/fngoods'),
            meta: {
                title: "已发货",
                requireAuth: true
            }
        },
        {
            path: '/fngoodsdetails',
            name: 'Fngoodsdetails',
            component: () =>
                import ('@/views/fngoods/fngoodsdetails'),
            meta: {
                title: "已发货详情",
                requireAuth: true
            }
        },
        {
            path: '/signin',
            name: 'Signin',
            component: () =>
                import ('@/views/signin/signin'),
            meta: {
                title: "已签收",
                requireAuth: true
            }
        },
        {
            path: '/signindetails',
            name: 'Signindetails',
            component: () =>
                import ('@/views/signin/signindetails'),
            meta: {
                title: "已收货详情",
                requireAuth: true
            }
        },
        {
            path: '/signinselfaccess',
            name: 'Signinselfaccess',
            component: () =>
                import ('@/views/signin/signinselfaccess'),
            meta: {
                title: "已签收详情",
                requireAuth: true
            }
        },
        {
            path: '/addres',
            name: 'Addres',
            component: () =>
                import ('@/views/addres/addres'),
            meta: {
                title: "地址管理",
                requireAuth: true
            }
        },
        {
            path: '/addaddres',
            name: 'Addaddres',
            component: () =>
                import ('@/views/addres/addaddres'),
            meta: {
                title: "新增地址",
                requireAuth: true
            }
        },
        {
            path: '/editaddres',
            name: 'Editaddres',
            component: () =>
                import ('@/views/addres/editaddres'),
            meta: {
                title: "修改地址",
                requireAuth: true
            }
        },
        {
            path: '/redenvelopes',
            name: 'Redenvelopes',
            component: () =>
                import ('@/views/redenvelopes/redenvelopes'),
            meta: {
                title: "红包管理",
                requireAuth: true
            }
        },
        {
            path: '/scanningcode',
            name: 'Scanningcode',
            component: () =>
                import ('@/views/scanningcode/scanningcode'),
            meta: {
                title: "扫码记录",
                requireAuth: true
            }
        },
        {
            path: '/Actively',
            name: 'Actively',
            component: () =>
                import ('@/views/Actively/ActiveList'),
            meta: {
                title: "活动列表",
                requireAuth: true
            }
        },
        {
            path: '/activedetail',
            name: 'ActiveDetail',
            component: () =>
                import ('@/views/Actively/ActiveDetail'),
            meta: {
                title: "活动详情",
                requireAuth: true,
            }
        },
        {
            path: '/tothestore',
            name: 'Tothestore',
            component: () =>
                import ('@/views/tothestore/tothestore'),
            meta: {
                title: "确认订单",
                requireAuth: true,
            }
        },
        {
            path: '/selset',
            name: 'Selset',
            component: () =>
                import ('@/views/tothestore/selset'),
            meta: {
                title: "选择门店",
                requireAuth: true,
            }
        },
        {
            path: '/tothestoresucces',
            name: 'Tothestoresucces',
            component: () =>
                import ('@/views/tothestore/tothestoresucces'),
            meta: {
                title: "下单成功",
                requireAuth: true,
            }
        },
        {
            path: '/kuaidi',
            name: 'Kuaidi',
            component: () =>
                import ('@/views/tothestore/kuaidi'),
            meta: {
                title: "确认订单",
                requireAuth: true,
            }
        },
        {
            path: '/kuaidisucces',
            name: 'Kuaidisucces',
            component: () =>
                import ('@/views/tothestore/Kuaidisucces'),
            meta: {
                title: "下单成功",
                requireAuth: true,
            }
        },


    ]
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js